import { useState } from 'react';

type Props = {
  open: boolean;
  anchor: 'left' | 'right';
  toggleDrawer: () => void;
  collapsedWidth?: number;
  expandedWidth?: number;
};
const DrawerToggleButton = ({ open, toggleDrawer, anchor }: Props) => {
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  const isLeft = anchor === 'left';

  const topPartClasses = open ? (isLeft ? 'rotate-12' : '-rotate-12') : isLeft ? '-rotate-12' : 'rotate-12';

  const bottomPartClasses = open ? (isLeft ? '-rotate-12' : 'rotate-12') : isLeft ? 'rotate-12' : '-rotate-12';

  const xAnchor = isLeft ? '-right-8' : '-left-8';

  return (
    <div
      onMouseEnter={() => setIsButtonHovered(true)}
      onMouseLeave={() => setIsButtonHovered(false)}
      aria-label="drawer-collapse"
      tabIndex={0}
      role="button"
      className={`absolute cursor-pointer ${xAnchor} opacity-50 hover:opacity-90 top-1/2 z-40 hidden md:flex -translate-y-1/2 transition-transform hover:scale-105`}
      onClick={toggleDrawer}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          toggleDrawer();
        }
      }}
    >
      <div className="px-1 py-4 flex justify-center items-center flex-col mx-1.5">
        <div
          className={`-mb-1 h-12 bg-brand-sky w-1.5 rounded transition-all duration-300 ${isButtonHovered ? topPartClasses : ''}`}
        ></div>
        <div
          className={`-mt-1 h-12 bg-brand-sky w-1.5 rounded transition-all duration-300 ${isButtonHovered ? bottomPartClasses : ''}`}
        ></div>
      </div>
    </div>
  );
};

export default DrawerToggleButton;
